module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAx0lEQVQ4T+2UvwqBURjGf49NGZTB7AK+yWJXMrgBq7swuQUDuQSTjTKzmiirzaAsyqhH9BH6Tv4sSs54np7fed/nfTsi4djOAukkDdhL2j1qCoCmwDIAKkiqvAoaSqoFHknUQhX9Csh2CegA6ziXU6DR2xnZLgORpPbJbPuzjL4FmgODuG0DXUnb8/jfrGgCNGNQA+hJmn0CuuZnuwWM/qD7tbzdsbuMbGeAPpADFrGtCowD38itVgRWQP0ytTyQChifXR8kbY6TisoUMV6Y6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/weilou_tab.png
// module id = 2ngl
// module chunks = 1